import React from "react";
import "./App.css";
import Header from "./components/Header";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";

import Footer from "./components/Footer";
import Contact from "./components/Contact";
import AboutMe from "./components/AboutMe";
import IdealNextJob from "./components/IdealNextJob";
import SoftSkills from "./components/SoftSkills";
import Hobbies from "./components/Hobbies";

function App() {
  return (
    <div className="App relative min-h-screen overflow-visible bg-transparent font-body text-text-color">
      <svg
        aria-hidden="true"
        className="absolute h-0 w-0"
        xmlns="http://www.w3.org/2000/svg"
      >
        <filter
          id="glass-blur"
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
          filterUnits="objectBoundingBox"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" />
        </filter>
      </svg>
      <nav
        className="hidden lg:flex fixed right-6 top-1/2 z-40 -translate-y-1/2 flex-col gap-2"
        aria-label="Section navigation"
      >
        <a className="glass-nav-item" href="#about">About</a>
        <a className="glass-nav-item" href="#experience">Experience</a>
        <a className="glass-nav-item" href="#skills">Skills</a>
        <a className="glass-nav-item" href="#ideal-next-job">Next Job</a>
        <a className="glass-nav-item" href="#education">Education</a>
        <a className="glass-nav-item" href="#projects">Projects</a>
        <a className="glass-nav-item" href="#hobbies">Hobbies</a>
        <a className="glass-nav-item" href="#soft-skills">Soft Skills</a>
        <a className="glass-nav-item" href="#contact">Contact</a>
      </nav>

      <Header />
      <main id="main-content">
        <AboutMe />
        <Experience />
        <Skills />
        <IdealNextJob />
        <Education />
        <Projects />
        <div className="relative z-10 mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-6 py-12 md:grid-cols-2">
          <Hobbies />
          <SoftSkills />
        </div>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
